import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Button, Flex } from "antd";
import { ColumnsType } from "antd/es/table";

import SText from "@/styles/SText";
import { User } from "@/types/user";

export type UseUserColumn = (props: {
  onDel: (id: string) => void;
  onResetPwd?: (id: string) => void;
}) => ColumnsType<User>

const useUserColumn: UseUserColumn = ({ onDel, onResetPwd, }) => {
  const { t } = useTranslation();

  const columns: ColumnsType<User> = useMemo(() => [
    {
      title: <SText text={t("purchase.supplierUserName")} />,
      key: "mobile",
      render: (_, item) => <SText text={item.mobile ?? ""} />,
    },
    {
      title: <SText text={t("purchase.supplierUser")} />,
      key: "mobile",
      render: (_, item) => <SText text={item.mobile ?? ""} />,
    },
    {
      title: t("common.opt"),
      key: "action",
      fixed: 'right',
      render: (_, item) => (
        <Flex>
          <Button type="link" danger onClick={() => onDel(item.id)}>
            {t("common.del")}
          </Button>
          {onResetPwd && <Button type="link" onClick={() => onResetPwd(item.id)}>
          {t("purchase.supplierReset")}
          </Button>}
        </Flex>
      ),
    },
  ], [t]);

  return columns;
}

export default useUserColumn;